// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"4bf7d8cf","80":"c620feba","100":"c1c0fb25","270":"3a0d95b7","314":"b709c4f4","346":"561c9e85","501":"a9fc5786","635":"587e9c79","748":"22a833ed"}[chunkId] + ".chunk.js";
};